import * as React from 'react';
import { SingleForm } from './Components';
import { SinglePageState } from './Types';
import { IPackIdentifier, PackIdentifier } from '../../../../Types/PackIdentifier';
import { DashboardPage, ActionButton, RagBadge, SinglePackResponse } from '../../Components';
import 'Utils/Extensions';
import { BarcodeScannerHandler } from '../../../../Services/BarcodeScannerHandler';
import History from '../../../../Utils/History';
import { EventHandlerProvider } from '../../../../Services/EventHandlerService';
import { NeedToCalibrateScannerWarningEvent, ActionCannotBeUndone } from '../../../../Types';
import { PackAction } from '../../Types';
import { IAuthenticatedAppData } from '../../../../AuthenticatedApp/AuthenticatedApp';
import { SinglePackRequestService } from '../../../../Services/SinglePackRequestService';
import { Row, Col } from 'reactstrap';
import { VeriLiteWarningEvent } from '../../../../Types';
import * as SignalR from "@microsoft/signalr";
import { postJson, UserRequestHeaders } from '../../../../Services/Util';
import { Auth } from '../../../../Services/AuthenticationService';

interface ISingleProps {
    applicationData: IAuthenticatedAppData;
}

interface ISingleState {
    currentState: SinglePageState;
    packIdentifier: IPackIdentifier;
    selectedAction: PackAction;
    result: any;
}

export class Single extends React.Component<ISingleProps, ISingleState> {
    barcodeScannerHandler: any;
    scannedData: any;

    constructor(props: ISingleProps) {
        super(props);

        if (this.props.applicationData.userInfo.UserRole.match(/SuperUser/g)) {
            History.push('/Dashboard/Reports');
        }
        
        if (this.props.applicationData.calibrationData == null) {
            EventHandlerProvider.GetInstance().AddEvent(NeedToCalibrateScannerWarningEvent(this.props.applicationData.resources));
            History.push('/Dashboard/Safe');
        }
        this.barcodeScannerHandler = new BarcodeScannerHandler(this.parseScannerInput.bind(this));
        this.scannedData = {};
        
        this.state = {
            currentState: SinglePageState.Waiting,
            packIdentifier: new PackIdentifier(),
            selectedAction: props.applicationData.availableActions && props.applicationData.availableActions.length != 0 ? props.applicationData.availableActions[0] : PackAction.None,
            result: {}
        };

        document.addEventListener("keypress",
            this.barcodeScannerHandler.keyPressHandler,
            true);

        document.addEventListener("keydown",
            this.barcodeScannerHandler.keyDownHandler,
            true);

        document.addEventListener("keyup",
            this.barcodeScannerHandler.keyUpHandler,
            true);
    }

    componentDidUpdate(prevProps: ISingleProps) {
        if (prevProps.applicationData.selectedLocation != this.props.applicationData.selectedLocation && this.props.applicationData.calibrationData == null) {
            History.push('/Dashboard/Safe');
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keypress",
            this.barcodeScannerHandler.keyPressHandler,
            true);

        document.removeEventListener("keydown",
            this.barcodeScannerHandler.keyDownHandler,
            true);

        document.removeEventListener("keyup",
            this.barcodeScannerHandler.keyUpHandler,
            true);
    }

    parseScannerInput(dom3KeyboardEventCodeSupport: any) {
        if (this.props.applicationData.connectionState != SignalR.HubConnectionState.Connected) {
            EventHandlerProvider.GetInstance().AddEvent(new VeriLiteWarningEvent(this.props.applicationData.resources.VeriLiteDisconnected));
            return;
        }

        if (this.state.currentState === SinglePageState.Scanning || this.state.currentState === SinglePageState.Sending) {
            return;
        }

        if (dom3KeyboardEventCodeSupport) {
            this.scannedData = this.barcodeScannerHandler.scannerInput.getInput();
        } else {
            this.scannedData = this.barcodeScannerHandler.scannerInput.getInputBytes();
        }
        let scannedString = String.fromCharCode(...this.scannedData);
        if (this.scannedData.length > 20) {
            if (this.props.applicationData.calibrationData == null) {
                EventHandlerProvider.GetInstance().AddEvent(NeedToCalibrateScannerWarningEvent(this.props.applicationData.resources));
                return;
            }

            this.setState({
                currentState: SinglePageState.Scanning,
                packIdentifier: new PackIdentifier()
            }, () => {
                    this.parsePackData(JSON.stringify({ ScannedData: scannedString, CalibrationData: this.props.applicationData.calibrationData }));
            });
        }
    }

    parsePackData = (json: string) => {
        const headers = new UserRequestHeaders( { Organisation: Auth.getUser().Organisation, Location: Auth.getUser().Location, id: Auth.getUser().id });
        postJson(`/Parser/Parse`, json, undefined, undefined,  headers)
        .then((result: IPackIdentifier) => {
                if (result.submit) {
                    this.setState({
                        packIdentifier: result,
                        currentState: SinglePageState.Sending
                    }, () => {
                        SinglePackRequestService.SubmitPackRequest(result, this.state.selectedAction, false, this.props.applicationData.selectedLocation, this.props.applicationData.resources).then((singlePackResult) => {
                            this.setState({
                                result: singlePackResult,
                                currentState: SinglePageState.Result
                            });
                        }).catch((err) => {
                            console.error(err);
                            this.setState({
                                currentState: SinglePageState.Error
                            });
                        });
                    });
                }
                else {
                    console.error("Display error");
                    this.setState({
                        result: {
                            packInfo: {
                                Warning: this.props.applicationData.resources.CannotParseBarcode
                            },
                            ragClass: "Red"
                        },
                        currentState: SinglePageState.Result
                    });}
            });
    };

    actionButtonOnClick = (action: PackAction) => {
        if (this.state.currentState === SinglePageState.Scanning || this.state.currentState === SinglePageState.Sending) {
            return;
        }

        if (action.value == PackAction.MarkAsDestroyed.value || action.value == PackAction.MarkAsStolen.value) {
            EventHandlerProvider.GetInstance().AddEvent(
                ActionCannotBeUndone(
                    this.props.applicationData.resources,
                    () => {
                        this.setState(
                            {
                                selectedAction: action
                            }
                        );
                    })
            );
        } else {
            this.setState(
                {
                    selectedAction: action
                }
            );
        }
    };

    
    render() {
        return (
            <DashboardPage
                content={
                    <div>
                        <SingleForm currentState={this.state.currentState} packIdentifier={this.state.packIdentifier} resources={this.props.applicationData.resources} />
                        {this.state.currentState === SinglePageState.Result &&
                            <SinglePackResponse result={this.state.result} resources={this.props.applicationData.resources} showHelpLink={this.props.applicationData.showHelpLink} packIdentifier={this.state.packIdentifier} />
                        }
                    </div>
                }
                actions={!Array.isNullOrEmpty(this.props.applicationData.availableActions) &&
                    <div>
                    {this.props.applicationData.availableActions.map((action: PackAction) =>
                            <ActionButton
                                key={action.value}
                                action={action}
                                onClick={() => { this.actionButtonOnClick(action); }}
                                active={this.state.selectedAction == action} />
                        )}
                    </div>
                }
                placeholder={this.props.applicationData.resources.ActionsWillAppear_Single}
                title={this.props.applicationData.resources.PackDetails}
                resources={this.props.applicationData.resources}
            />
        );
    }
}